module.exports = __webpack_public_path__ + "img/1478010450.98b519b0.jpg";